import _ from "lodash";
import * as Yup from "yup";
import { useEffect } from "react";
import { useFormik } from "formik";
import { SimpleGrid } from "@chakra-ui/layout";
import { useDispatch } from "react-redux";
import { ToastService } from "../../../../services/toast.service";
import { FormDropdown } from "../../../common/form-controllers/FormDropdown";
import { FormTextArea } from "../../../common/form-controllers/FormTextArea";
import { useObjChange } from "../../../hooks";
// import ModuleBucketName from "./components/ModuleBucketName";
import { FormRadioGroup } from "../../../common/form-controllers/FormRadioGroup";
import { FormRadioButton } from "../../../common/form-controllers/FormRadioButton";
import { ChakraTableColumns } from "../../../common/chakra-table/ChakraTable";
import { SectionCardCreatable } from "../../../common/section-card/SectionCard";
import { MODULE, MODULE_BUCKET } from "../../../../consts/methods.consts";
import PageHeader, { PageHeaderActions } from "../../../common/page-header/PageHeader";
import { Stack, useDisclosure, useToast } from "@chakra-ui/react";
import { apiService, useGetQuery, usePostMutation } from "../../../../services/api.service";
import { NavigateFunction, useNavigate, useParams } from "react-router-dom";
import { DROPDOWN_TAGS, MODULE_BUCKET_TAGS, MODULE_TAGS } from "../../../../consts/tags.consts";
import { ChakraModal, ChakraTable, InnerLoading, SectionCard } from "../../..";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { chakraComponents } from "chakra-react-select";
import FormSelect from "../../../common/form-controllers/FormSelect";
import { FormInput } from "../../../common/form-controllers/FormInput";
import DocumentHeaderTitle from "../../../common/document-header-title/DocumentHeaderTitle";


const ViewModuleBucketPage = () => {
    const { id } = useParams()
    const navigate: NavigateFunction = useNavigate();
    const toast = new ToastService(useToast());
    const dispatch: any = useDispatch()
    const disclosure = useDisclosure()
    const [create, { isLoading: creating }] = usePostMutation();

    const { data: _data, isLoading, isFetching } = useGetQuery({
        method: MODULE_BUCKET.GET,
        body: { id },
        providesTags: [MODULE_BUCKET_TAGS.VIEW]
    })

    const { data: initData, isFetching: moduleIsFetching } = useGetQuery({
        method: MODULE_BUCKET.INIT,
        body: { id },
        providesTags: [MODULE_TAGS.VIEW, DROPDOWN_TAGS.LIST]

    }, { refetchOnMountOrArgChange: true })


    const data = _.get(_data, ['message'], {})

    const stringifiedData = JSON.stringify(data)

    const formik = useFormik({
        initialValues: {},
        validationSchema: Yup.object({
            title: Yup.string().required("Title is required"),
        }),
        onSubmit: async (values: any) => {
            try {
                const res = await create({
                    method: MODULE_BUCKET.UPDATE,
                    body: values,
                    invalidatesTags: [MODULE_BUCKET_TAGS.VIEW, MODULE_BUCKET_TAGS.LIST, DROPDOWN_TAGS.LIST]
                }).unwrap();

                toast.setTitle("Success").setDescription("Module basket details have been saved.").showSuccessToast();

            } catch (error: any) {
                // const errorMessage = _.get(error, 'data.exception').split(':')[1]
                // toast.setTitle("Error").setDescription(errorMessage).showErrorToast();

                const errorMessage = JSON.parse(JSON.parse(_.get(error, 'data._server_messages', '{}'))[0])?.message
                const type = JSON.parse(JSON.parse(_.get(error, 'data._server_messages', '{}'))[0])?.title
                if (type === 'warning') toast.setTitle("Warning").setStatus('warning').setDescription(errorMessage).show()
                else toast.setTitle("Error").setDescription(errorMessage).showErrorToast()
            }
        }
    })

    const deleteHandler = async () => {
        try {
            await create({
                method: MODULE_BUCKET.DELETE,
                body: { id },
                invalidatesTags: [MODULE_BUCKET_TAGS.LIST, DROPDOWN_TAGS.LIST]
            }).unwrap();

            toast.setTitle("Success").setDescription("Module basket is deleted successfully.").showSuccessToast();

            setTimeout(() => {
                navigate(`/app/module-basket`);
            }, 1500)

        } catch (error: any) {
            let message = JSON.parse(_.get(error?.data, '_server_messages', {}))
            if (message) toast.setTitle("Error").setDescription(JSON.parse(message)?.message.replace(/<[^>]*>?/gm, '')).showErrorToast();
            // toast.setTitle("Error").setDescription('Failed to delete the module basket').showErrorToast();
        }
    }

    const childFormik = useFormik({
        initialValues: { type: 'Elective' },
        validationSchema: Yup.object({
            name: Yup.string().required("Please select a module"),
            type: Yup.string().required("Please select a type"),
            // defaultValue={"Elective"}
        }),
        onSubmit: async (values: any) => {

            const alreadyExsist = _.get(formik.values, 'modules', []).findIndex((line: any) => (line.name === values.name))

            if (alreadyExsist > -1) {
                toast.setTitle("Error").setDescription("This Module Already exists").showErrorToast();
                return
            }
            disclosure.onClose()
            // GET_MODULE_MODULE_DETAILS
            try {
                const res = await dispatch(apiService.endpoints.get.initiate({
                    method: MODULE.GET,
                    body: { id: values.name },
                    providesTags: []
                })).unwrap()

                if (_.get(res, 'message')) formik.setFieldValue('modules', [
                    ..._.get(formik.values, 'modules', []),
                    { ..._.get(res, 'message'), type: values?.type }
                ])

                childFormik.resetForm()

            } catch (error) {
                toast.setTitle("Error").setDescription("Unable to update Module Basket data. Please try again").showErrorToast();
                console.error(error);
            }
        }
    })

    const moduleOptions = (_.get(initData, 'message.modules', [])).filter((OptionModule: any) => !_.get(formik.values, 'modules', []).some((tableModule: any) => OptionModule.value === tableModule.name))
    const moduleBucketTypes = _.get(initData, 'message.module_bucket_types', [])

    const { isChanged, setInitialObj } = useObjChange(formik.values)

    useEffect(() => {
        if (!_.isEmpty(data)) {
            formik.setValues(data)
            setInitialObj(data)
        }
    }, [stringifiedData])

    const MODULE_LIST_TABLE_COLUMNS: ChakraTableColumns = [
        {
            header: "Module Code",
            accessor: "code",
        },
        {
            header: "Name",
            accessor: "title",
        },
        {
            header: "Credit",
            accessor: "credit",
        },
        {
            header: "Duration",
            accessor: "duration_hours",
        },
        {
            header: "Type",
            accessor: "type"
        },
        {
            header: "Action",
            accessor: "",
            width: 100,
            options: [
                {
                    label: "Delete",
                    onClick(item: any) {
                        const newItems = _.get(formik.values, 'modules', []).filter((i: any) => (
                            i?.name !== item?.name
                        ))
                        formik.setFieldValue('modules', newItems)
                    },
                }
            ]
        },
    ]

    const actions: PageHeaderActions = [
        {
            text: "Save",
            isDisabled: !isChanged,
            onClick: formik.submitForm,
            buttonVariant: "solid",
            buttonColorScheme: "teal"
        },
        {
            text: "Delete",
            onClick: deleteHandler,
            buttonVariant: "solid",
            buttonColorScheme: "red"
        }
    ]

    const creatable: SectionCardCreatable = {
        text: "Add New",
        onClick: () => {
            disclosure.onOpen();
        }
    }

    if (isLoading) {
        return (
            <>
                <PageHeader isLoading={isLoading} enableBackButton actions={actions} title={'Module Basket'} />
                <InnerLoading />
            </>
        )
    }

    return (
        <div>
            <PageHeader backButtonCofirmation={isChanged} isLoading={isLoading || creating} enableBackButton actions={actions} title={_.get(data, 'title', '')}
                subtitle={'Module Basket'} />
            <DocumentHeaderTitle>
                {_.get(data, 'title', '')}
            </DocumentHeaderTitle>
            <SectionCard backgroundColor="bg-white" title="Basic Information" p={3}>
                <SimpleGrid columns={{ base: 1, md: 2, lg: 3, xl: 3 }} spacing={3}>
                    <FormInput isRequired label="Basket Name" formik={formik} name="title" />
                    <FormDropdown options={moduleBucketTypes} formik={formik} name={'type'}
                        autoFocus
                        label={'Basket Type'} />
                    {/* <FormTextArea label="Description" rows={8} formik={formik} name="description" /> */}
                </SimpleGrid>
            </SectionCard>

            <SectionCard creatable={creatable} title="Modules" p={3}>
                <ChakraTable size={"sm"} header
                    columns={MODULE_LIST_TABLE_COLUMNS}
                    data={_.get(formik.values, 'modules', [])} />
                <ChakraModal primaryAction={childFormik.submitForm} primaryButtonText={"Add"}
                    modalTitle={'Add new module'} {...disclosure}>
                    <SimpleGrid columns={{ base: 1, md: 1, lg: 1, xl: 1 }} spacing={3}>
                        <FormSelect components={customComponents} options={moduleOptions} isRequired formik={childFormik} name={'name'}
                            label={'Module'} />
                        <FormRadioGroup name={"type"} defaultValue="Elective" formik={childFormik}>
                            <Stack direction='row'>
                                <FormRadioButton name="type" formik={childFormik} value='Mandatory' label='Mandatory' />
                                <FormRadioButton name="type" formik={childFormik} value='Elective' label='Elective' />
                            </Stack>
                        </FormRadioGroup>
                    </SimpleGrid>
                </ChakraModal>
            </SectionCard>
        </div>
    )
}

export default ViewModuleBucketPage

const customComponents = {
    Option: ({ children, ...props }: any) => (
        <chakraComponents.Option {...props}>
            <div className="gap-2">
                <div className=" font-bold">
                    {children}
                </div>
                <div className=" italic flex  gap-3">
                    <span className="bg-blue-100 text-blue-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">
                        {props.data.code}
                    </span>
                    {props.data.group && (<span className="bg-yellow-100 text-yellow-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-yellow-900 dark:text-yellow-300">
                        {props.data.group}
                    </span>)}
                </div>
            </div>
        </chakraComponents.Option >
    )
};